import React from 'react';
import PropTypes from 'prop-types';
import KpiChart from '../../../commons/KpiChart';

const StudentAccessFrequencyGauge = (props) => (
  <KpiChart
    title="Access count"
    description="The amount of days that  students that studied at least once accessed the system."
    loading={props.loading}
    currentValue={props.currentValue}
    previousValue={props.previousValue}
    intervals={[0, 4, 8, 12]}
    stepSize={4}
    reverseColors={false}
    formatter={props.formatter}
    onClickHistory={props.onClickHistory}
  />
);

StudentAccessFrequencyGauge.propTypes = {
  loading: PropTypes.bool.isRequired,
  currentValue: PropTypes.number.isRequired,
  previousValue: PropTypes.number.isRequired,
  onClickHistory: PropTypes.func,
  formatter: PropTypes.func.isRequired,
};

StudentAccessFrequencyGauge.propTypes = {
  onClickHistory: null,
};

export default StudentAccessFrequencyGauge;
